import React from 'react';

export default function ShieldShareIcon() {
    return (
        <svg
            width="104"
            height="128"
            viewBox="0 0 104 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_866_59426)">
                <path
                    d="M47.6378 123.637C49.0215 124.438 49.7133 124.839 50.6897 125.046C51.4475 125.208 52.553 125.208 53.3107 125.046C54.2871 124.839 54.979 124.438 56.3627 123.637C68.538 116.589 102 94.4498 102 64.01V34.3517C102 29.3935 102 26.9144 101.183 24.7834C100.461 22.9008 99.2878 21.221 97.7649 19.8893C96.0409 18.3817 93.7015 17.5112 89.0227 15.7703L55.5115 3.30102C54.2121 2.81754 53.5625 2.5758 52.8941 2.47997C52.3013 2.39497 51.6992 2.39497 51.1064 2.47997C50.438 2.5758 49.7884 2.81754 48.489 3.30102L14.9778 15.7703C10.299 17.5112 7.95959 18.3817 6.23561 19.8893C4.71263 21.221 3.53946 22.9008 2.8175 24.7834C2.00025 26.9144 2.00024 29.3935 2.00024 34.3517V64.01C2.00024 94.4498 35.4625 116.589 47.6378 123.637Z"
                    stroke="#0080FF"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M41.9921 62.4145L58.7825 72.1986M58.7579 45.2062L41.9921 54.9903M72.4999 41.4941C72.4999 45.5672 69.1981 48.8691 65.125 48.8691C61.0519 48.8691 57.75 45.5672 57.75 41.4941C57.75 37.421 61.0519 34.1191 65.125 34.1191C69.1981 34.1191 72.4999 37.421 72.4999 41.4941ZM43 58.7024C43 62.7755 39.6981 66.0774 35.625 66.0774C31.5519 66.0774 28.25 62.7755 28.25 58.7024C28.25 54.6293 31.5519 51.3274 35.625 51.3274C39.6981 51.3274 43 54.6293 43 58.7024ZM72.4999 75.9107C72.4999 79.9838 69.1981 83.2857 65.125 83.2857C61.0519 83.2857 57.75 79.9838 57.75 75.9107C57.75 71.8376 61.0519 68.5357 65.125 68.5357C69.1981 68.5357 72.4999 71.8376 72.4999 75.9107Z"
                    stroke="#0080FF"
                    strokeWidth="4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_866_59426">
                    <rect
                        width="104"
                        height="128"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
